export const I18N_AVAILABLE_LOCALES = ['it'] as const;
export const DEFAULT_LOCALE = I18N_AVAILABLE_LOCALES[0];
export type LocaleType = (typeof I18N_AVAILABLE_LOCALES)[number];
